export const LicenseStylesColums = {
  buttonContainer: {
    display: "flex",
    alignItems: "left",
    gap: 0.5,
    justifyContent: "left",
    width: "100%",
  },
  buttonTextTransform: {
    textTransform: "none",
  },
  popoverBox: {
    p: 2,
    maxWidth: 220,
  },
  popoverTypography: {
    mb: 1.5,
  },
  popoverActionsBox: {
    display: "flex",
    gap: 1,
    justifyContent: "flex-end",
  },
  statusBadge: {
    padding: "4px 8px",
    borderRadius: "12px",
    display: "inline-block",
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  statusDot: {
    height: 10,
    width: 10,
    borderRadius: "50%",
    display: "inline-block",
    marginRight: 5,
  },
  expiryChip: {
    height: 10,
    width: 10,
    marginRight: 5,
  },
  statusColors: {
    all: {
      color: "#757575",
      bg: "#f5f5f5",
    },
    active: {
      color: "#4CAF50",
      bg: "#e7f4dc",
    },
    unassigned: {
      color: "#3478F6",
      bg: "#a3caf4",
    },
    upcoming: {
      color: "#7A58C1",
      bg: "#E0D3E8",
    },
    expired: {
      color: "#B71C1C",
      bg: "#d58884",
    },
  },
};
